import { render } from "./AllLawCategories.vue?vue&type=template&id=562eccf5"
import script from "./AllLawCategories.vue?vue&type=script&lang=js"
export * from "./AllLawCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__